import ColumnChart from '../../../../components/Charts/ColumnChart'
import { InfoContainer, SubTitle } from '../../styles'

export default function CustomersByMonth ({ data: customers }) {
  if (!customers || Object.keys (customers).length === 0) {
    return null
  }

  return (
    <InfoContainer>
      <SubTitle>Clientes por mês</SubTitle>
      <ColumnChart
        data={customers}
        legendPosition='top'
        options={{
          height: 350,
          colors: ['#FFC100', '#35A7FF', '#44CF6C'],
          legend: 'none',
          chartArea: { top: 20, left: 110, width: '75%', height: '75%' },
          vAxis: {
            title: 'Clientes',
            minValue: 0,
            titleTextStyle: { bold: true }
          }
        }}
      />
    </InfoContainer>
  )
}
